/**
 * Filename (under `~/.alchemy/credentials/{profile}/`) used to cache the
 * Cloudflare-deployed HTTP state store's endpoint + bearer token.
 *
 * Kept in this leaf module (rather than `StateStore/State.ts`) so the
 * Cloudflare auth provider can invalidate the cache on
 * `login --configure` / `logout` without importing the heavy state-store
 * module and creating an import cycle
 * (`StateStore/State.ts` -> `Providers.ts` -> `Auth/AuthProvider.ts`).
 */
export const CREDENTIALS_FILE = "cloudflare-state-store";
/**
 * `true` when cached state-store credentials must not be trusted for the
 * current account:
 *
 * - the file predates the `accountId` field (legacy cache — exactly the
 *   artifact that caused deploys to silently target the wrong account), or
 * - it was minted against a different account than the one now in use.
 *
 * A stale cache is discarded and re-derived from the current account.
 */
export const isStateStoreCredentialsStale = (credentials, currentAccountId) => credentials.accountId == null || credentials.accountId !== currentAccountId;
//# sourceMappingURL=CredentialsFile.js.map